import { render, staticRenderFns } from "./CommunicationCreate.vue?vue&type=template&id=5bc5a5c8&scoped=true&"
import script from "./CommunicationCreate.vue?vue&type=script&lang=js&"
export * from "./CommunicationCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc5a5c8",
  null
  
)

export default component.exports